import { useEffect, useSyncExternalStore } from 'react';

/**
 * Folhas que pedem uma decisão antes de qualquer outra coisa (chave de
 * recuperação, confirmação de identidade). Enquanto uma está aberta, as
 * outras esperam: nada de folha em cima de folha.
 */
let open = 0;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Marca que esta folha está na tela enquanto `active` for verdadeiro. */
export function useBlockingSheet(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    open += 1;
    for (const listener of listeners) listener();
    return () => {
      open -= 1;
      for (const listener of listeners) listener();
    };
  }, [active]);
}

export function useBlockingSheetOpen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => open > 0,
    () => false,
  );
}
